import { academyApi } from '../clients/AxiosClients'
/**
 *
 *@param {string} searchKey - Palavra chave busca
 *@returns {Promise} - Retorna uma promise com a resposta da requisição
 */
const getSearchClasses = async (searchKey) => {
	return academyApi.get('api/v1/TreeviaAcademy/buscaAulas', {
		params: {
			searchKey: searchKey,
		},
	})
}

const getAllclasses = async () => {
	return academyApi.get('api/v1/TreeviaAcademy/listaTodasAulas')
}

export { getAllclasses, getSearchClasses }
